/**
 * Priority bands (PRD §5.2): A ≥3.8, B 2.5–3.8, C below.
 *
 * Separate from the component for the same reason as `stages.ts`.
 */
export const BANDS = ['A', 'B', 'C'] as const;

export type Band = (typeof BANDS)[number];

/** Tint per band, from the semantic palette. */
export const BAND_STYLE: Record<Band, string> = {
  A: 'bg-sem-ok-bg text-sem-ok',
  B: 'bg-sem-info-bg text-sem-info',
  C: 'bg-sem-mute-bg text-sem-mute',
};
